import styled, { css } from 'styled-components';

export const ColorBox = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin-bottom: ${theme.spacings[10]};
    padding: ${theme.spacings[12]};
    border-radius: 12px;
    background: ${theme.colors.white || '#fff'};
    border: 1px solid ${theme.colors.gray200 || '#e4e9f2'};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings[12]};
  `}
`;

export const ColorHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  font-weight: 600;
  font-size: 14px;

  svg {
    font-size: 16px;
  }
`;

export const ColorGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 600;
    opacity: 0.8;
  }
`;

export const ColorInput = styled.input`
  width: 100%;
  height: 38px;
  padding: 4px 6px;
  border-radius: 8px;
  border: 1px solid #d5dbe7;
  background: #f9fbff;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.blue700};
    box-shadow: 0 0 0 2px rgba(76, 139, 245, 0.15);
  }

  &:hover {
    background: #f4f8ff;
  }

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border: none;
    border-radius: 6px;
  }
`;
